module.exports = __webpack_public_path__ + "media/images/SKYPRIVATE-e5d5fd1aa7e3ddf9c069048c841a9802.svg";